import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Content, Layout } from 'apps/dashboard/shared/scripts/components';
import { PageLoader } from 'apps/shared/scripts/components';
import { PRO_MODE_ENABLED } from 'apps/shared/scripts/feature-gating/constants';
import useFeatureGate from 'apps/shared/scripts/feature-gating/hooks';
import {
  useIsCardDelivered,
  useIsCardPro,
  useOnError,
} from 'apps/shared/scripts/hooks';

import CheckoutFormContainer from '../CheckoutFormContainer';

import messages from './messages.json';

const CheckoutContainer = () => {
  const { cardId } = useParams();
  const { onError } = useOnError();
  const { isPro, isLoading: isLoadingPro } = useIsCardPro({
    id: cardId!,
    onError,
  });
  const { isDelivered, isLoading: isLoadingDelivered } = useIsCardDelivered({
    id: cardId!,
    onError,
  });
  const navigate = useNavigate();

  const isProModeEnabled = useFeatureGate(PRO_MODE_ENABLED);

  useEffect(() => {
    if (!isLoadingPro && !isLoadingDelivered && (isPro || isDelivered)) {
      navigate(`/dashboard/cards/${cardId}`, { replace: true });
    }
    // eslint-disable: allow success screen to appear after an upgrade event
  }, [isLoadingPro, isLoadingDelivered]); // eslint-disable-line

  if (isLoadingPro || isLoadingDelivered) {
    return <PageLoader />;
  }

  return (
    <Layout>
      <Content
        backTo={`/dashboard/cards/${cardId!}`}
        title={messages.checkoutTitle}
      >
        {isProModeEnabled && <CheckoutFormContainer cardId={cardId!} />}
      </Content>
    </Layout>
  );
};

CheckoutContainer.displayName = 'CheckoutContainer';

export default CheckoutContainer;
